<template>
  <div class="vescor-container">
    <video
      ref="videoPlayer"
      src="https://vwingist.oss-cn-shanghai.aliyuncs.com/melscn/file/2025/05/5656239175334102874.mp4"
      loop
      muted
      class="fullscreen-video"
    ></video>
    <div class="sound-icon flex-rowc" @click="toggleSound">
      <!-- <img
        :src="isMuted ? '/assets/sound.png' : '/assets/sound.png'"
        alt="Sound Icon"
      /> -->
      <div class="sound-tip" v-if="isMuted"></div>
      <img :src="require('@/assets/images/no-sound.png')" alt="" v-if="isMuted" />
      <img :src="require('@/assets/images/sound.png')" alt="" v-else />
    </div>
    <!-- 入口 -->
    <div class="entry" @click="handleGo">
      <img :src="require('@/assets/images/enter.png')" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Vescor",
  data() {
    return {
      isMuted: true,
    };
  },
  mounted() {
    const video = this.$refs.videoPlayer;
    video.play().catch((error) => {
      console.error("视频播放失败:", error);
    });
  },
  methods: {
    // 跳转
    handleGo() {
      this.$router.push("/Home");
    },
    toggleSound() {
      const video = this.$refs.videoPlayer;
      video.muted = !this.isMuted;
      this.isMuted = !this.isMuted;
    },
  },
};
</script>

<style lang="less">
.vescor-container {
  margin: 0;
  padding: 0;
  height: 100vh;
  position: relative;
  overflow: hidden;

  .fullscreen-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
  }
  .sound-icon {
    position: absolute;
    bottom: 64px;
    right: 104px;
    width: 55px;
    height: 55px;
    background: rgba(255, 255, 255, .1);
    border-radius: 50%;
    cursor: pointer;
    img {
      width: 35px;
      height: 35px;
    }
    .sound-tip {
      position: absolute;
      width: 170px;
      height: 69px;
      background: url('..//assets/images/openSound.png') no-repeat center;
      background-size: cover;
      top: -72px;
    }
  }
  .entry {
    width: 260px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 20%;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
}
</style>